import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import Default from './Default/Container';

const HouseholdSummaryPagePicker = (props) => {
  const { userResource } = useUserContext();

  return pickFunction(userResource, {
    [fr.relationships.default.name]: () => {
      return (
        <Default {...props} />
      );
    },
  });
};

export default HouseholdSummaryPagePicker;
